import { Dot } from "lucide-react";

const ITEMS = [
  "Registration Renewal",
  "Title Transfers",
  "VIN Verification",
  "Duplicate Titles",
  "Commercial Plates",
  "Out-of-State Transfers",
  "Sticker Replacement",
  "Walk-Ins Welcome",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      aria-label="Services strip"
      className="border-y border-slate-200 bg-white overflow-hidden"
    >
      <div className="relative">
        <div className="animate-marquee whitespace-nowrap flex items-center py-5">
          {row.map((label, i) => (
            <span
              key={`${label}-${i}`}
              className="inline-flex items-center text-slate-700"
            >
              <span className="font-display text-lg sm:text-xl font-medium tracking-tight px-6">
                {label}
              </span>
              <Dot className="h-6 w-6 text-blue-600 shrink-0" />
            </span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
}
